export const customErrorTypes = {
    // M2: shown as the /cp save-error toast when PayoutsModuleExtensions rejects an
    // illegal payout status transition (forward-only lifecycle). The key matches the
    // 'ADMIN_' + API message that errorCommit sets on admin.error.message; EntryForm's
    // admin.error watcher renders it via processErrors (single toast — no core touch).
    ADMIN_PAYOUT_INVALID_STATUS_TRANSITION:
        'Payout status can only move forward: pending → processed → paid. Going back or skipping a step is not allowed.',

    // M2: rejected when a payout is created via /cp with a status other than pending
    // (PayoutsModuleExtensions::guardCreateStatus) — the lifecycle must start at pending.
    ADMIN_PAYOUT_MUST_START_PENDING:
        'A new payout must start with the "pending" status. Advance it to processed/paid afterwards.',

    // M2: rejected when advancing a payout that has no recipient — there would be no
    // partner to notify (PayoutsModuleExtensions::guardRecipientPresent).
    ADMIN_PAYOUT_HAS_NO_RECIPIENT:
        'This payout has no recipient, so its status can\'t be advanced. Attach a partner (User) first.',

    // M2: the native "Delete Entry" is blocked for referrals — use the Remove button,
    // which requires a reason and refuses referrals that already have commissions.
    ADMIN_REFERRAL_USE_REMOVE_BUTTON:
        'Use the "Remove referral" button (it requires a reason) instead of Delete Entry.',

    // M2-120: only a super administrator may delete or duplicate commissions/payouts,
    // edit or delete a super administrator's account, change direct permissions or change
    // their own roles (CpCaller::requireSuperAdministrator).
    ADMIN_SUPER_ADMIN_ONLY:
        'Only a Super Administrator can do this. Nothing was changed.',

    // M2-120: granting or removing the Super Administrator role. Usually accidental —
    // removing the only role tag auto-selects the first option, Super Administrator.
    ADMIN_SUPER_ADMIN_ROLE_ONLY:
        'Only a Super Administrator can grant or remove the Super Administrator role. Nothing was saved. If you removed the only role, "Super Administrator" was added in its place: remove it and pick the right role.',
};
